export const CATALOG = [
  // ── Microsoft Azure ─────────────────────────────────────────────
  {
    id: 'az-104', vendor: 'Microsoft Azure', title: 'AZ-104 · Azure Administrator Associate',
    cover: 'cover-az', logo: 'https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-ar21.svg',
    items: 325, time: '8 hrs', difficulty: 'Intermediate', popular: true, cat: 'cloud',
  },
  {
    id: 'az-900', vendor: 'Microsoft Azure', title: 'AZ-900 · Azure Fundamentals',
    cover: 'cover-az', logo: 'https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-ar21.svg',
    items: 195, time: '4 hrs', difficulty: 'Beginner', cat: 'cloud',
  },
  {
    id: 'az-305', vendor: 'Microsoft Azure', title: 'AZ-305 · Azure Infrastructure Solutions',
    cover: 'cover-az', logo: 'https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-ar21.svg',
    items: 280, time: '9 hrs', difficulty: 'Advanced', popular: true, cat: 'cloud',
  },
  {
    id: 'az-500', vendor: 'Microsoft Azure', title: 'AZ-500 · Azure Security Engineer',
    cover: 'cover-az', logo: 'https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-ar21.svg',
    items: 245, time: '8 hrs', difficulty: 'Advanced', cat: 'security',
  },
  {
    id: 'az-700', vendor: 'Microsoft Azure', title: 'AZ-700 · Azure Networking Solutions',
    cover: 'cover-az', logo: 'https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-ar21.svg',
    items: 210, time: '7 hrs', difficulty: 'Intermediate', cat: 'cloud',
  },
  {
    id: 'az-204', vendor: 'Microsoft Azure', title: 'AZ-204 · Azure Developer Associate',
    cover: 'cover-az', logo: 'https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-ar21.svg',
    items: 260, time: '8 hrs', difficulty: 'Intermediate', cat: 'devops',
  },
  {
    id: 'az-400', vendor: 'Microsoft Azure', title: 'AZ-400 · Azure DevOps Engineer Expert',
    cover: 'cover-az', logo: 'https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-ar21.svg',
    items: 300, time: '10 hrs', difficulty: 'Advanced', popular: true, cat: 'devops',
  },
  {
    id: 'az-140', vendor: 'Microsoft Azure', title: 'AZ-140 · Azure Virtual Desktop Specialty',
    cover: 'cover-az', logo: 'https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-ar21.svg',
    items: 185, time: '6 hrs', difficulty: 'Intermediate', cat: 'cloud',
  },

  // ── Microsoft 365 ───────────────────────────────────────────────
  {
    id: 'ms-900', vendor: 'Microsoft 365', title: 'MS-900 · Microsoft 365 Fundamentals',
    cover: 'cover-ms365', logo: 'https://www.vectorlogo.zone/logos/microsoft/microsoft-ar21.svg',
    items: 165, time: '3 hrs', difficulty: 'Beginner', cat: 'microsoft365',
  },
  {
    id: 'ms-102', vendor: 'Microsoft 365', title: 'MS-102 · Microsoft 365 Administrator Expert',
    cover: 'cover-ms365', logo: 'https://www.vectorlogo.zone/logos/microsoft/microsoft-ar21.svg',
    items: 295, time: '9 hrs', difficulty: 'Advanced', popular: true, cat: 'microsoft365',
  },
  {
    id: 'ms-700', vendor: 'Microsoft 365', title: 'MS-700 · Managing Microsoft Teams',
    cover: 'cover-ms365', logo: 'https://www.vectorlogo.zone/logos/microsoft/microsoft-ar21.svg',
    items: 215, time: '6 hrs', difficulty: 'Intermediate', cat: 'microsoft365',
  },
  {
    id: 'ms-203', vendor: 'Microsoft 365', title: 'MS-203 · Microsoft 365 Messaging',
    cover: 'cover-ms365', logo: 'https://www.vectorlogo.zone/logos/microsoft/microsoft-ar21.svg',
    items: 220, time: '7 hrs', difficulty: 'Intermediate', cat: 'microsoft365',
  },

  // ── Microsoft Security & Compliance ────────────────────────────
  {
    id: 'sc-900', vendor: 'Microsoft Security', title: 'SC-900 · Security, Compliance & Identity Fundamentals',
    cover: 'cover-sc', logo: 'https://www.vectorlogo.zone/logos/microsoft/microsoft-ar21.svg',
    items: 175, time: '3 hrs', difficulty: 'Beginner', cat: 'security',
  },
  {
    id: 'sc-200', vendor: 'Microsoft Security', title: 'SC-200 · Security Operations Analyst',
    cover: 'cover-sc', logo: 'https://www.vectorlogo.zone/logos/microsoft/microsoft-ar21.svg',
    items: 250, time: '8 hrs', difficulty: 'Intermediate', popular: true, cat: 'security',
  },
  {
    id: 'sc-300', vendor: 'Microsoft Security', title: 'SC-300 · Identity and Access Administrator',
    cover: 'cover-sc', logo: 'https://www.vectorlogo.zone/logos/microsoft/microsoft-ar21.svg',
    items: 235, time: '7 hrs', difficulty: 'Intermediate', cat: 'security',
  },
  {
    id: 'sc-100', vendor: 'Microsoft Security', title: 'SC-100 · Microsoft Cybersecurity Architect',
    cover: 'cover-sc', logo: 'https://www.vectorlogo.zone/logos/microsoft/microsoft-ar21.svg',
    items: 270, time: '9 hrs', difficulty: 'Advanced', cat: 'security',
  },

  // ── Power Platform ──────────────────────────────────────────────
  {
    id: 'pl-900', vendor: 'Microsoft Power Platform', title: 'PL-900 · Power Platform Fundamentals',
    cover: 'cover-power', logo: 'https://www.vectorlogo.zone/logos/microsoft/microsoft-ar21.svg',
    items: 150, time: '3 hrs', difficulty: 'Beginner', cat: 'microsoft365',
  },
  {
    id: 'pl-400', vendor: 'Microsoft Power Platform', title: 'PL-400 · Power Platform Developer',
    cover: 'cover-power', logo: 'https://www.vectorlogo.zone/logos/microsoft/microsoft-ar21.svg',
    items: 240, time: '8 hrs', difficulty: 'Intermediate', cat: 'microsoft365',
  },
  {
    id: 'pl-100', vendor: 'Microsoft Power Platform', title: 'PL-100 · Power Platform App Maker',
    cover: 'cover-power', logo: 'https://www.vectorlogo.zone/logos/microsoft/microsoft-ar21.svg',
    items: 180, time: '5 hrs', difficulty: 'Beginner', cat: 'microsoft365',
  },

  // ── GitHub ──────────────────────────────────────────────────────
  {
    id: 'gh-900', vendor: 'GitHub', title: 'GitHub Foundations',
    cover: 'cover-gh', logo: 'https://www.vectorlogo.zone/logos/github/github-ar21.svg',
    items: 145, time: '4 hrs', difficulty: 'Beginner', cat: 'devops',
  },
  {
    id: 'gh-200', vendor: 'GitHub', title: 'GH-200 · GitHub Actions',
    cover: 'cover-gh', logo: 'https://www.vectorlogo.zone/logos/github/github-ar21.svg',
    items: 195, time: '6 hrs', difficulty: 'Intermediate', popular: true, cat: 'devops',
  },
  {
    id: 'gh-500', vendor: 'GitHub', title: 'GH-500 · GitHub Advanced Security',
    cover: 'cover-gh', logo: 'https://www.vectorlogo.zone/logos/github/github-ar21.svg',
    items: 210, time: '7 hrs', difficulty: 'Intermediate', cat: 'security',
  },
  {
    id: 'gh-100', vendor: 'GitHub', title: 'GH-100 · GitHub Administration',
    cover: 'cover-gh', logo: 'https://www.vectorlogo.zone/logos/github/github-ar21.svg',
    items: 175, time: '5 hrs', difficulty: 'Intermediate', cat: 'devops',
  },

  // ── Amazon AWS ──────────────────────────────────────────────────
  {
    id: 'aws-saa', vendor: 'Amazon Web Services', title: 'AWS Solutions Architect — Associate (SAA-C03)',
    cover: 'cover-aws', logo: 'https://www.vectorlogo.zone/logos/amazon_aws/amazon_aws-ar21.svg',
    items: 390, time: '10 hrs', difficulty: 'Intermediate', popular: true, cat: 'cloud',
  },
  {
    id: 'aws-clf', vendor: 'Amazon Web Services', title: 'AWS Cloud Practitioner (CLF-C02)',
    cover: 'cover-aws', logo: 'https://www.vectorlogo.zone/logos/amazon_aws/amazon_aws-ar21.svg',
    items: 215, time: '5 hrs', difficulty: 'Beginner', cat: 'cloud',
  },
  {
    id: 'aws-dva', vendor: 'Amazon Web Services', title: 'AWS Developer Associate (DVA-C02)',
    cover: 'cover-aws', logo: 'https://www.vectorlogo.zone/logos/amazon_aws/amazon_aws-ar21.svg',
    items: 310, time: '9 hrs', difficulty: 'Intermediate', cat: 'devops',
  },
  {
    id: 'aws-sysops', vendor: 'Amazon Web Services', title: 'AWS SysOps Administrator Associate',
    cover: 'cover-aws', logo: 'https://www.vectorlogo.zone/logos/amazon_aws/amazon_aws-ar21.svg',
    items: 280, time: '8 hrs', difficulty: 'Intermediate', cat: 'cloud',
  },
  {
    id: 'aws-sap', vendor: 'Amazon Web Services', title: 'AWS Solutions Architect — Professional',
    cover: 'cover-aws', logo: 'https://www.vectorlogo.zone/logos/amazon_aws/amazon_aws-ar21.svg',
    items: 420, time: '14 hrs', difficulty: 'Advanced', popular: true, cat: 'cloud',
  },
  {
    id: 'aws-sec', vendor: 'Amazon Web Services', title: 'AWS Security Specialty',
    cover: 'cover-aws', logo: 'https://www.vectorlogo.zone/logos/amazon_aws/amazon_aws-ar21.svg',
    items: 265, time: '9 hrs', difficulty: 'Advanced', cat: 'security',
  },

  // ── Google Cloud ────────────────────────────────────────────────
  {
    id: 'gcp-ace', vendor: 'Google Cloud', title: 'Google Cloud Associate Cloud Engineer',
    cover: 'cover-gcp', logo: 'https://www.vectorlogo.zone/logos/google_cloud/google_cloud-ar21.svg',
    items: 280, time: '7 hrs', difficulty: 'Intermediate', cat: 'cloud',
  },
  {
    id: 'gcp-pca', vendor: 'Google Cloud', title: 'Google Cloud Professional Cloud Architect',
    cover: 'cover-gcp', logo: 'https://www.vectorlogo.zone/logos/google_cloud/google_cloud-ar21.svg',
    items: 330, time: '10 hrs', difficulty: 'Advanced', popular: true, cat: 'cloud',
  },
  {
    id: 'gcp-pde', vendor: 'Google Cloud', title: 'Google Cloud Professional Data Engineer',
    cover: 'cover-gcp', logo: 'https://www.vectorlogo.zone/logos/google_cloud/google_cloud-ar21.svg',
    items: 295, time: '9 hrs', difficulty: 'Advanced', cat: 'cloud',
  },
  {
    id: 'gcp-cdl', vendor: 'Google Cloud', title: 'Google Cloud Digital Leader',
    cover: 'cover-gcp', logo: 'https://www.vectorlogo.zone/logos/google_cloud/google_cloud-ar21.svg',
    items: 175, time: '4 hrs', difficulty: 'Beginner', cat: 'cloud',
  },

  // ── CompTIA ─────────────────────────────────────────────────────
  {
    id: 'sec-plus', vendor: 'CompTIA', title: 'CompTIA Security+ (SY0-701)',
    cover: 'cover-comp', logo: 'https://www.vectorlogo.zone/logos/comptia/comptia-ar21.svg',
    items: 395, time: '12 hrs', difficulty: 'Intermediate', popular: true, cat: 'security',
  },
  {
    id: 'net-plus', vendor: 'CompTIA', title: 'CompTIA Network+ (N10-009)',
    cover: 'cover-comp', logo: 'https://www.vectorlogo.zone/logos/comptia/comptia-ar21.svg',
    items: 340, time: '9 hrs', difficulty: 'Beginner', cat: 'networking',
  },
  {
    id: 'a-plus', vendor: 'CompTIA', title: 'CompTIA A+ Core 1 & Core 2 (220-1101/1102)',
    cover: 'cover-comp', logo: 'https://www.vectorlogo.zone/logos/comptia/comptia-ar21.svg',
    items: 460, time: '14 hrs', difficulty: 'Beginner', popular: true, cat: 'networking',
  },
  {
    id: 'cysa', vendor: 'CompTIA', title: 'CompTIA CySA+ (CS0-003)',
    cover: 'cover-comp', logo: 'https://www.vectorlogo.zone/logos/comptia/comptia-ar21.svg',
    items: 285, time: '9 hrs', difficulty: 'Intermediate', cat: 'security',
  },
  {
    id: 'pentest', vendor: 'CompTIA', title: 'CompTIA PenTest+ (PT0-002)',
    cover: 'cover-comp', logo: 'https://www.vectorlogo.zone/logos/comptia/comptia-ar21.svg',
    items: 260, time: '9 hrs', difficulty: 'Advanced', cat: 'security',
  },
  {
    id: 'casp', vendor: 'CompTIA', title: 'CompTIA CASP+ (CAS-004)',
    cover: 'cover-comp', logo: 'https://www.vectorlogo.zone/logos/comptia/comptia-ar21.svg',
    items: 310, time: '10 hrs', difficulty: 'Advanced', cat: 'security',
  },
  {
    id: 'cloud-plus', vendor: 'CompTIA', title: 'CompTIA Cloud+ (CV0-004)',
    cover: 'cover-comp', logo: 'https://www.vectorlogo.zone/logos/comptia/comptia-ar21.svg',
    items: 245, time: '8 hrs', difficulty: 'Intermediate', cat: 'cloud',
  },

  // ── Cisco ───────────────────────────────────────────────────────
  {
    id: 'ccna', vendor: 'Cisco', title: 'CCNA 200-301',
    cover: 'cover-cisco', logo: 'https://www.vectorlogo.zone/logos/cisco/cisco-ar21.svg',
    items: 450, time: '14 hrs', difficulty: 'Intermediate', popular: true, cat: 'networking',
  },
  {
    id: 'ccnp-ent', vendor: 'Cisco', title: 'CCNP Enterprise ENCOR (350-401)',
    cover: 'cover-cisco', logo: 'https://www.vectorlogo.zone/logos/cisco/cisco-ar21.svg',
    items: 380, time: '12 hrs', difficulty: 'Advanced', cat: 'networking',
  },
  {
    id: 'ccnp-sec', vendor: 'Cisco', title: 'CCNP Security SCOR (350-701)',
    cover: 'cover-cisco', logo: 'https://www.vectorlogo.zone/logos/cisco/cisco-ar21.svg',
    items: 355, time: '11 hrs', difficulty: 'Advanced', cat: 'security',
  },

  // ── Linux Foundation / Kubernetes ───────────────────────────────
  {
    id: 'lfcs', vendor: 'Linux Foundation', title: 'LFCS · Linux Foundation Certified Sysadmin',
    cover: 'cover-linux', logo: 'https://www.vectorlogo.zone/logos/linuxfoundation/linuxfoundation-ar21.svg',
    items: 240, time: '8 hrs', difficulty: 'Intermediate', cat: 'linux',
  },
  {
    id: 'cka', vendor: 'Linux Foundation', title: 'CKA · Certified Kubernetes Administrator',
    cover: 'cover-k8s', logo: 'https://www.vectorlogo.zone/logos/kubernetes/kubernetes-ar21.svg',
    items: 290, time: '10 hrs', difficulty: 'Advanced', popular: true, cat: 'linux',
  },
  {
    id: 'ckad', vendor: 'Linux Foundation', title: 'CKAD · Certified Kubernetes Application Developer',
    cover: 'cover-k8s', logo: 'https://www.vectorlogo.zone/logos/kubernetes/kubernetes-ar21.svg',
    items: 255, time: '9 hrs', difficulty: 'Intermediate', cat: 'devops',
  },
  {
    id: 'cks', vendor: 'Linux Foundation', title: 'CKS · Certified Kubernetes Security Specialist',
    cover: 'cover-k8s', logo: 'https://www.vectorlogo.zone/logos/kubernetes/kubernetes-ar21.svg',
    items: 275, time: '9 hrs', difficulty: 'Advanced', cat: 'security',
  },

  // ── Salesforce ──────────────────────────────────────────────────
  {
    id: 'sf-adm', vendor: 'Salesforce', title: 'Salesforce Certified Administrator (ADM-201)',
    cover: 'cover-sf', logo: 'https://www.vectorlogo.zone/logos/salesforce/salesforce-ar21.svg',
    items: 320, time: '8 hrs', difficulty: 'Intermediate', popular: true, cat: 'salesforce',
  },
  {
    id: 'sf-adv', vendor: 'Salesforce', title: 'Salesforce Advanced Administrator (ADM-211)',
    cover: 'cover-sf', logo: 'https://www.vectorlogo.zone/logos/salesforce/salesforce-ar21.svg',
    items: 280, time: '7 hrs', difficulty: 'Advanced', cat: 'salesforce',
  },
  {
    id: 'sf-pd1', vendor: 'Salesforce', title: 'Salesforce Certified Platform Developer I',
    cover: 'cover-sf', logo: 'https://www.vectorlogo.zone/logos/salesforce/salesforce-ar21.svg',
    items: 295, time: '8 hrs', difficulty: 'Intermediate', popular: true, cat: 'salesforce',
  },
  {
    id: 'sf-pd2', vendor: 'Salesforce', title: 'Salesforce Certified Platform Developer II',
    cover: 'cover-sf', logo: 'https://www.vectorlogo.zone/logos/salesforce/salesforce-ar21.svg',
    items: 340, time: '11 hrs', difficulty: 'Advanced', cat: 'salesforce',
  },
  {
    id: 'sf-sales', vendor: 'Salesforce', title: 'Salesforce Certified Sales Cloud Consultant',
    cover: 'cover-sf', logo: 'https://www.vectorlogo.zone/logos/salesforce/salesforce-ar21.svg',
    items: 255, time: '7 hrs', difficulty: 'Intermediate', cat: 'salesforce',
  },
  {
    id: 'sf-service', vendor: 'Salesforce', title: 'Salesforce Certified Service Cloud Consultant',
    cover: 'cover-sf', logo: 'https://www.vectorlogo.zone/logos/salesforce/salesforce-ar21.svg',
    items: 265, time: '7 hrs', difficulty: 'Intermediate', cat: 'salesforce',
  },
  {
    id: 'sf-data', vendor: 'Salesforce', title: 'Salesforce Certified Data Cloud Consultant',
    cover: 'cover-sf', logo: 'https://www.vectorlogo.zone/logos/salesforce/salesforce-ar21.svg',
    items: 230, time: '6 hrs', difficulty: 'Advanced', cat: 'salesforce',
  },
  {
    id: 'sf-mktg', vendor: 'Salesforce', title: 'Salesforce Certified Marketing Cloud Consultant',
    cover: 'cover-sf', logo: 'https://www.vectorlogo.zone/logos/salesforce/salesforce-ar21.svg',
    items: 245, time: '6 hrs', difficulty: 'Intermediate', cat: 'salesforce',
  },

  // ── ServiceNow ──────────────────────────────────────────────────
  {
    id: 'sn-csa', vendor: 'ServiceNow', title: 'ServiceNow Certified System Administrator (CSA)',
    cover: 'cover-sn', logo: 'https://www.vectorlogo.zone/logos/servicenow/servicenow-ar21.svg',
    items: 290, time: '7 hrs', difficulty: 'Intermediate', popular: true, cat: 'servicenow',
  },
  {
    id: 'sn-cad', vendor: 'ServiceNow', title: 'ServiceNow Certified Application Developer (CAD)',
    cover: 'cover-sn', logo: 'https://www.vectorlogo.zone/logos/servicenow/servicenow-ar21.svg',
    items: 310, time: '9 hrs', difficulty: 'Advanced', popular: true, cat: 'servicenow',
  },
  {
    id: 'sn-itsm', vendor: 'ServiceNow', title: 'ServiceNow CIS — IT Service Management (ITSM)',
    cover: 'cover-sn', logo: 'https://www.vectorlogo.zone/logos/servicenow/servicenow-ar21.svg',
    items: 270, time: '8 hrs', difficulty: 'Intermediate', cat: 'servicenow',
  },
  {
    id: 'sn-hr', vendor: 'ServiceNow', title: 'ServiceNow CIS — HR Service Delivery',
    cover: 'cover-sn', logo: 'https://www.vectorlogo.zone/logos/servicenow/servicenow-ar21.svg',
    items: 240, time: '7 hrs', difficulty: 'Intermediate', cat: 'servicenow',
  },
  {
    id: 'sn-secops', vendor: 'ServiceNow', title: 'ServiceNow CIS — Security Operations (SecOps)',
    cover: 'cover-sn', logo: 'https://www.vectorlogo.zone/logos/servicenow/servicenow-ar21.svg',
    items: 260, time: '8 hrs', difficulty: 'Advanced', cat: 'servicenow',
  },
  {
    id: 'sn-itom', vendor: 'ServiceNow', title: 'ServiceNow CIS — IT Operations Management (ITOM)',
    cover: 'cover-sn', logo: 'https://www.vectorlogo.zone/logos/servicenow/servicenow-ar21.svg',
    items: 255, time: '8 hrs', difficulty: 'Advanced', cat: 'servicenow',
  },
  {
    id: 'sn-pa', vendor: 'ServiceNow', title: 'ServiceNow Micro-Certification — Performance Analytics',
    cover: 'cover-sn', logo: 'https://www.vectorlogo.zone/logos/servicenow/servicenow-ar21.svg',
    items: 185, time: '5 hrs', difficulty: 'Beginner', cat: 'servicenow',
  },
];
